import React, { useEffect, useState } from "react";
import CreateModelHeader from "./components/CreateModelHeader";
import CreateModelProgress from "./components/CreateModelProgress";
import { useNavigate } from "react-router-dom";
import FormikControl from "../../components/signUpForm/ReusableFormik/FormikControl";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { ModelContext } from "./DataContext";
import { useContext } from "react";

function CreateModelStep4(){
    const  navigate = useNavigate();
    const {saveModelData} = useContext(ModelContext);
    const {modelData} = useContext(ModelContext);
    const [tScore, setTotalscore] = useState(0);

    // const formik = useFormik({
    //     initialValues: {
    //       passMark: " ",
    //       score: " "

    //     }, validate: (values) => {
    //         const errors = {};       
    //             if(!values.score){
    //                 errors.score = "This field is required";
    //             } 

    //             if(!values.passMark){
    //                 errors.passMark = "This field is required";
    //             }                         
    //         return errors;
    //     }, 
    //     onSubmit: (values) =>{
            
    //     }
    // })

    // const handleInputChangePm= (event) =>{
    //     setPassMark(event.target.value);
    // }

    // const handleInputChangeScore= (event) =>{
    //     setSocore(event.target.value);
    // }

    
    const validationSchema = Yup.object({
        passMark: Yup.string().required("Required"),
        score: Yup.string().required("Required"),
      })

    const initialValues =  {
        passMark: "",
        score: "",

      }

    
    // const scores = [
    //     { value: 10, label: 'Average debit' },
    //     { value: 10, label: 'Average credit' },
    //     { value: 10, label: 'Average debit' },
    //     { value: 10, label: 'Average debit' },
    //     { value: 10, label: 'Average debit' },
    //     { value: 10, label: 'Average debit' },
    //     { value: 10, label: 'Average debit' },
    //     { value: 10, label: 'Average debit' },
    //     { value: 10, label: 'Average debit' },
    // ];

    const scores = [
        { value: modelData.score1_0, label: modelData.variable1_0  },
        { value: modelData.score2_0, label: modelData.variable2_0},
        { value: modelData.score1, label: modelData.variable1 },
        { value: modelData.score2, label: modelData.variable2,},
        
    ];

    useEffect(()=>{
        let sum = 0;
        for(let data of scores){
            sum += Number(data.value);
        }

        setTotalscore(sum);
    })


    const onSubmit =(values) =>{
        const totScore = {totalScore: tScore}
        saveModelData({...totScore, ...values})
        navigate('/CreateModelStep5');
        console.log("context data ",modelData);
    }
    
    return(
        <div>
            <div>
                <CreateModelHeader/>
            </div>
            <div>
                <CreateModelProgress title={'Create Predition Model'} indexActualPage={4}/>
            </div>

            <div className="flex items-center flex-col">
                 <h1 className="mt-3 sm:text-sm xl:text-lg">Here are the scores as previously stated, please review and edit if needed</h1>
                 <table className="mt-2 table-fixed border-collapse border border-2 disabled-btn w-[321px] rounded-lg">
                    <thead className="rounded-lg">
                        <tr  className="border border-2 disabled-btn bg-disabled-btn">
                            <th className="p-1 pl-3 text-start">Variable</th>
                            <th className="p-1 text-start">Assigned Score</th>
                        </tr>
                        
                    </thead>

                    <tbody>
                        {scores.map((option) => (
                        
                            <tr className="border border-2 disabled-btn">
                                <td className="p-1  pl-3">{option.label}</td>
                                <td className="pl-1">{option.value}</td>
                            </tr>
                        ))}
                        
                        {/*<tr className="border border-2 disabled-btn">
                            <td className="p-1  pl-3">Average debit aaaaaa</td>
                            <td>10</td>
                        </tr>
                        <tr className="border border-2 disabled-btn">
                            <td className="p-1  pl-3">Total outstanding Loan</td>
                            <td>10</td>
                        </tr>
                        <tr className="border border-2 disabled-btn">
                            <td className="p-1  pl-3">Average debit</td>
                            <td>10</td>
                        </tr>
                        <tr className="border border-2 disabled-btn">
                            <td className="p-1  pl-3">Average debit</td>
                            <td>10</td>
                        </tr>
                        <tr className="border border-2 disabled-btn">
                            <td className="p-1  pl-3">Average debit</td>
                            <td>10</td>
                        </tr>
                        <tr className="border border-2 disabled-btn">
                            <td className="p-1  pl-3">Average debit</td>
                            <td>10</td>
                        </tr>
                        <tr className="border border-2 disabled-btn">
                            <td className="p-1 pl-3">Average debit</td>
                            <td>10</td>
                        </tr>
                        <tr className="border border-2 disabled-btn">
                            <td className="p-1 pl-3">Average debit</td>
                            <td>10</td>
                        </tr>*/}
                        </tbody>

                    <tfoot className="bg-disabled-btn">
                        <th className="p-1 pl-3 text-start">Total</th>
                        <th className="p-1 text-start">{tScore}</th>
                    </tfoot>
                </table>

                <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
            >
                    {(formik) => {
                        return (
                            <div className="mt-5 w-[321px]">
                                <Form className="">
                                    
                                    <FormikControl
                                        control="input"
                                        label="Pass Mark (required)"
                                        type="text"                                       
                                        name="passMark"                              
                                    />  
                                    <div className="mt-5">
                                        <FormikControl
                                            control="input"
                                            label="Least considerable score"
                                            type="text"
                                            name="score"
                                        />

                                    </div>
                                    
                                    <span className="flex justify-center mt-20 mb-20">
                                        <button     
                                            type="submit" 
                                            className='bg-indigo-500 hover:bg-indigo-600 text-slate-50 border rounded-md xl:px-5 md:px-2 lg:px-3 xl:py-2 md:w-28 xl:w-[150px] xl:h-[56px] sm:w-28 sm:h-12 sm;text-xs' 
                                            disabled={!formik.isValid}>
                                            Continue
                                        </button>
                                    </span>
                                
                                </Form>
                            </div>
                            
                        );
                    }}
                </Formik>          
            </div>

        </div>
    )
}
export default CreateModelStep4



                 {/* <div className="mt-3 w-80">
                    <form>
                        <div className="flex flex-col mr-4"> 
                        <div>
                            <label className="block text-xs sm:text-sm md:text-base font-normal mb-2 mt-8" htmlFor="passMark">Pass mark (required)</label>
                            <CustomInput
                                    id={"passMark"}
                                    name={"passMark"}
                                    type={'text'}
                                    value={formik.values.passMark}
                                    placeholder=''
                                    onChangeInput={handleInputChangePm}
                                    formik={formik}
                                 
                                />
                        </div>   
                        {formik.errors.passMark && formik.touched.passMark ?
                                    <span className="text-red-500 text-xs mt-1">{formik.errors.passMark}</span> : null
                        }

                        <div  className="">
                            <label className="block text-xs sm:text-sm md:text-base font-normal mb-2 mt-8" htmlFor="score">Least considerable score</label>
                            <CustomInput
                                id={"score"}
                                name={"score"}
                                type={'text'}
                                value= {formik.values.score}
                                placeholder=''                           
                                // className={"pb-3"}
                                onChangeInput={handleInputChangeScore}
                                formik={formik}
                            />
                        </div> 
                        {formik.errors.score && formik.touched.score ?
                                    <span className="text-red-500 text-xs mt-1">{formik.errors.score}</span> : ""
                        }

                        </div>
                    </form>
      

                    export default CreateModelStep4;*/}